export class Admin {
  id: number;
  name: string;
  username: string;
  password: string;
  isSuperAdmin: boolean;
  infos: string;
  time: string;
  isActive: boolean;

  constructor() {
    this.isSuperAdmin = false;
    this.isActive = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/models/admin.ts